import React from 'react';
import ColorfulIcon from './ColorfulIcon';
import { whatWeDo } from '../mockData';

const iconGradients = {
  Network: 'blue',
  Cloud: 'teal',
  Shield: 'purple',
  Laptop: 'indigo'
};

const WhatWeDo = () => {
  return (
    <section id="services" className="py-6 bg-gray-50 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-6">
          <p className="text-blue-600 text-sm font-semibold tracking-wider uppercase mb-2" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Text, sans-serif' }}>
            What We Do
          </p>
          <h2 className="text-4xl md:text-5xl font-semibold text-gray-900 mb-3" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Display, sans-serif', letterSpacing: '-0.02em' }}>
            Comprehensive IT Solutions
          </h2>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Text, sans-serif' }}>
            From network infrastructure to cloud services, R-Technos delivers end-to-end
            technology solutions tailored to your business needs.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {whatWeDo.map((service) => {
            return (
              <div
                key={service.id}
                className="group bg-white border border-gray-200 rounded-3xl p-8 hover:shadow-xl transition-all duration-300"
              >
                <div className="flex items-start gap-6">
                  <ColorfulIcon 
                    icon={service.icon} 
                    size={28} 
                    gradient={iconGradients[service.icon]} 
                  />
                  <div>
                    <h3 className="text-2xl font-semibold text-gray-900 mb-3" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Display, sans-serif' }}>{service.title}</h3>
                    <p className="text-gray-600 leading-relaxed" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Text, sans-serif' }}>{service.description}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;